"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAddressSchema = exports.consigneeSearchSchema = exports.listActivityQuerySchema = exports.listUsersQuerySchema = exports.assignRoleSchema = exports.updateUserSchema = exports.createUserSchema = exports.resetPasswordSchema = exports.forgotPasswordSchema = exports.changePasswordSchema = exports.loginSchema = exports.LANGUAGES = void 0;
const zod_1 = require("zod");
const password_1 = require("./password");
const phone_1 = require("./phone");
const roles_1 = require("./roles");
exports.LANGUAGES = ['en', 'ar', 'ur', 'hi'];
const email = zod_1.z
    .string()
    .trim()
    .toLowerCase()
    .pipe(zod_1.z.email().max(254));
// staff accounts: UAE or a foreign number with its country code (couriers use their own UAE-only rule)
const staffMobile = zod_1.z
    .string()
    .trim()
    .transform((v, ctx) => {
    const n = (0, phone_1.normalizeStaffMobile)(v);
    if (!n) {
        ctx.addIssue({ code: 'custom', message: 'INVALID_PHONE' });
        return zod_1.z.NEVER;
    }
    return n;
});
const password = zod_1.z.string().min(1).max(password_1.PASSWORD_MAX_LENGTH);
/** Login with email or UAE mobile number. */
exports.loginSchema = zod_1.z.object({
    identifier: zod_1.z.string().trim().min(1).max(254),
    password,
});
exports.changePasswordSchema = zod_1.z.object({
    currentPassword: password,
    newPassword: password,
});
exports.forgotPasswordSchema = zod_1.z.object({ email });
exports.resetPasswordSchema = zod_1.z.object({
    token: zod_1.z.string().min(20).max(200),
    newPassword: password,
});
/** Blink's staff ID (D-0020): letters, digits, - or _ */
const blinkId = zod_1.z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z0-9][A-Z0-9_-]{0,23}$/, 'CODE_FORMAT');
const userBase = {
    fullName: zod_1.z.string().trim().min(2).max(120),
    blinkId: blinkId.nullish().or(zod_1.z.literal('').transform(() => null)),
    email: email.nullish(),
    phone: staffMobile.nullish(),
    language: zod_1.z.enum(exports.LANGUAGES).default('en'),
};
exports.createUserSchema = zod_1.z
    .object({
    ...userBase,
    temporaryPassword: password.optional(),
})
    .refine((u) => u.email || u.phone, { message: 'EMAIL_OR_PHONE_REQUIRED', path: ['email'] });
exports.updateUserSchema = zod_1.z.object({
    fullName: userBase.fullName.optional(),
    blinkId: userBase.blinkId,
    email: email.nullish(),
    phone: staffMobile.nullish(),
    language: zod_1.z.enum(exports.LANGUAGES).optional(),
    status: zod_1.z.enum(['ACTIVE', 'DISABLED']).optional(),
    reason: zod_1.z.string().trim().max(500).optional(),
});
exports.assignRoleSchema = zod_1.z.object({
    roleCode: zod_1.z.enum(roles_1.ROLE_CODES),
    hubId: zod_1.z.uuid().nullish(),
    /** team leader / dispatcher: a hub role may also name one project (D-0020) */
    projectId: zod_1.z.uuid().nullish(),
    reason: zod_1.z.string().trim().max(500).optional(),
});
exports.listUsersQuerySchema = zod_1.z.object({
    search: zod_1.z.string().trim().max(100).optional(),
    status: zod_1.z.enum(['ACTIVE', 'DISABLED']).optional(),
    roleCode: zod_1.z.enum(roles_1.ROLE_CODES).optional(),
    page: zod_1.z.coerce.number().int().min(1).default(1),
    pageSize: zod_1.z.coerce.number().int().min(1).max(100).default(50),
});
exports.listActivityQuerySchema = zod_1.z.object({
    actorUserId: zod_1.z.uuid().optional(),
    action: zod_1.z.string().trim().max(100).optional(),
    entityType: zod_1.z.string().trim().max(50).optional(),
    entityId: zod_1.z.string().trim().max(100).optional(),
    from: zod_1.z.coerce.date().optional(),
    to: zod_1.z.coerce.date().optional(),
    /** id of the last row seen (keyset paging, newest first) */
    before: zod_1.z.coerce.bigint().optional(),
    pageSize: zod_1.z.coerce.number().int().min(1).max(200).default(50),
});
exports.consigneeSearchSchema = zod_1.z.object({
    /** a mobile number (any format) or at least 3 letters of a name; empty = most recent customers (masked) */
    q: zod_1.z.string().trim().min(3).max(100).optional(),
    page: zod_1.z.coerce.number().int().min(1).max(1000).default(1),
});
exports.removeAddressSchema = zod_1.z.object({ reason: zod_1.z.string().trim().min(3).max(500) });
//# sourceMappingURL=schemas.js.map